<template>
  <div class="lotti-children-container">

    <div class="lotti-grid-row lotti-grid-row-mid">

      <div class="lotti-grid-col lotti-grid-col-66">

        <div class="lotti-module">

          <div class="lotti-module-title">{{ personTitle }}</div>

          <el-form :model="personForm" :rules="personRules" label-width="134px" ref="personForm" class="lotti-module-form">

            <div class="lotti-form-separator-50">

              <el-form-item label="Geschlecht" prop="gender">
                <el-radio-group v-model="personForm.gender">
                  <el-radio-button :label="false" :key="false">weiblich</el-radio-button>
                  <el-radio-button :label="true" :key="true">männlich</el-radio-button>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="Vorname" prop="firstname">
                <el-input placeholder="Bitte Vornamen eingeben" v-model="personForm.firstname"></el-input>
              </el-form-item>

              <el-form-item label="Nachname" prop="lastname">
                <el-input placeholder="Bitte Namen eingeben" v-model="personForm.lastname"></el-input>
              </el-form-item>

              <el-form-item label="Geburtsdatum" prop="birthday">
                <el-date-picker
                    v-model="personForm.birthday"
                    :picker-options="{ firstDayOfWeek: 1}"
                    format="dd.MM.yyyy"
                    type="date"
                    placeholder="Geburtsdatum eingeben">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="Telefon Nr." prop="phone">
                <el-input
                    type="textarea"
                    maxlength="200"
                    resize="none"
                    show-word-limit
                    placeholder="Person: +41 61 123 45 67"
                    v-model="personForm.phone">
                </el-input>
              </el-form-item>

              <el-form-item label="E-Mail" prop="email">
                <el-input v-model="personForm.email" placeholder="email@atticode.com"/>
              </el-form-item>

              <el-form-item label="Adresse" prop="address">
                <el-input
                    type="textarea"
                    maxlength="200"
                    resize="none"
                    show-word-limit
                    placeholder="Bitte Adresse eingeben"
                    v-model="personForm.address">
                </el-input>
              </el-form-item>

            </div>

            <div class="lotti-form-separator-50">

              <el-form-item label="Sprachen" prop="langValue">
                <el-select
                    v-model="personForm.langValue"
                    multiple
                    filterable
                    remote
                    :multiple-limit="5"
                    clearable
                    reserve-keyword
                    placeholder="Bitte eine Sprache eingeben"
                    :remote-method="remoteSearch"
                    :loading="langLoading">
                  <el-option
                      v-for="item in langOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Massnahme" prop="action">
                <el-select
                    clearable
                    filterable
                    v-model="personForm.action"
                    placeholder="Select">
                  <el-option
                      v-for="item in actionOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Abklärungsdatum" prop="clarificationDate">
                <el-date-picker
                    v-model="personForm.clarificationDate"
                    :picker-options="{ firstDayOfWeek: 1}"
                    type="date"
                    format="dd.MM.yyyy"
                    placeholder="Abklärungsdatum">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="Zugeordnet an" prop="therapist">
                <el-select
                    clearable
                    filterable
                    v-model="personForm.therapist"
                    placeholder="Therapeutin wählen">
                  <el-option
                      v-for="item in therapistOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Zugew. Dienst" prop="service">
                <el-select
                    clearable
                    filterable
                    v-model="personForm.service"
                    placeholder="Dienst wählen">
                  <el-option
                      v-for="item in serviceOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Zugew. Gemeinde" prop="community">
                <el-select
                    clearable
                    filterable
                    v-model="personForm.community"
                    placeholder="Gemeinde wählen">
                  <el-option
                      v-for="item in communityOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Archiviert" prop="isArchived">
                  <el-switch v-model="personForm.isArchived" active-color="rgb(158, 125, 255)"/>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="submitData">Speichern</el-button>
                <el-button type="secondary" @click="$router.push('/')">Zurück</el-button>
              </el-form-item>

            </div>

          </el-form>

        </div>
      </div>

      <div class="lotti-grid-col lotti-grid-col-33">
        <div class="lotti-module">
          <child-sessions-module :child-id="personForm.id"></child-sessions-module>
        </div>
      </div>

    </div>

  </div>
</template>


<script>
import Vue from '../../main.js';
import auth from '../../auth.js';
import langHelper from '../../Helpers/LanguageHelper';
import validation from '../../Helpers/ValidationHelper';
import datePickerHelper from '../../Helpers/DatePickerHelper.js';
import notification from '../../Helpers/NotificationHelper';

//modules to load
import childSessionsModule from '../modules/ChildSession';


//loading modules for tiles


export default {

  data() {
    return {

      auth: auth,
      errorAlert: null,

      personTitle: 'Neues Therapiekind',

      personForm: {
        id: null,
        firstname: null,
        lastname: null,
        birthday: null,
        langValue: [],
        phone: null,
        email: null,
        gender: true,//default for "male"
        address: null,
        action: null,
        clarificationDate: null,
        therapist: null,
        service: null,
        community: null,
        isArchived: false,
      },

      langOptions: [],
      langList: [],
      langLoading: false,
      languages: [],


      therapistOptions: [],
      serviceOptions: [],
      communityOptions: [],
      actionOptions: [
        {label: 'Warteliste', value: 'wait'},
        {label: 'Therapie', value: 'therapy'},
        {label: 'Kontrolle', value: 'control'},
        {label: 'Pause', value: 'pause'},
        {label: 'Abschluss', value: 'final'}
      ],

      personRules: {
        firstname: [
          validation.getMinMaxValidationObject(2, 45, 'change'),
          validation.getCustomAlphaValidationObject('change'),
          validation.getRequiredValidationObject('change')
        ],
        lastname: [
          validation.getMinMaxValidationObject(2, 45, 'change'),
          validation.getCustomAlphaValidationObject('change'),
          validation.getRequiredValidationObject('change')
        ],
        birthday: [
          validation.getRequiredValidationObject('change')
        ],
        phone: [
          validation.getMinMaxValidationObject(0, 200, 'change'),
        ],
        email: [
          validation.getMinMaxValidationObject(0, 50, 'change'),
          validation.getEmailValidationObject('change')
        ],
        langValue: [
          validation.getRequiredValidationObject('change'),
          // validation.getMinMaxValidationObject(0, 80, 'change'),
        ],
        address: [
          validation.getRequiredValidationObject('change'),
          validation.getMinMaxValidationObject(0, 200, 'change'),
        ],
        action: [
          validation.getRequiredValidationObject('change'),
        ],
        clarificationDate: [
          validation.getRequiredValidationObject('change'),
        ],
        therapist: [
          validation.getRequiredValidationObject('change'),
        ],
        service: [
          validation.getRequiredValidationObject('change'),
        ],
        community: [
          validation.getRequiredValidationObject('change'),
        ],
      },
    }
  },

  methods: {

    remoteSearch(query) {
      if (query !== '') {
        this.langLoading = true;
        setTimeout(() => {
          this.langLoading = false;
          this.langOptions = this.langList.filter(item => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.langOptions = [];
      }
    },

    submitData() {

      this.$refs['personForm'].validate((valid) => {

        if (valid) {
          Vue.http.post(
              //update or create? decide based on id field
              this.personForm.id ? 'api/v1/child/update' : 'api/v1/child/create',
              {
                id: this.personForm.id,
                firstname: this.personForm.firstname,
                lastname: this.personForm.lastname,
                birthday: datePickerHelper.formatUTCDateTimeUS(this.personForm.birthday),
                languages: this.personForm.langValue.join(),
                telnr: this.personForm.phone,
                email: this.personForm.email,
                gender: this.personForm.gender,
                isArchived: this.personForm.isArchived,
                address: this.personForm.address,
                action: this.personForm.action,
                clarification_date: datePickerHelper.formatUTCDateTimeUS(this.personForm.clarificationDate),
                therapist: this.personForm.therapist,
                service: this.personForm.service,
                community: this.personForm.community,
              }
          ).then(response => {

            //set id from sucesse response
            this.personForm.id = response.data.id;

            //set new title + show success
            this.personTitle = this.personForm.firstname + " " + this.personForm.lastname;

            //update the url via router push, only if ID is different
            if(Number(this.$route.params.childId) !== this.personForm.id) {
              this.$router.push('/child/' + this.personForm.id)
            }

            //show success msg
            notification.showSuccess(this, 'Daten wurden erfolgreich gespeichert');

          }, error => {
            notification.showError(this, 'Daten konnten nicht gespeichert werden');
          })
        }
      })
    },

    getChildData() {
      Vue.http.get(
          'api/v1/child/get-by-id',
          {
            params: {
              id: this.personForm.id,
            }
          }
      ).then(response => {

        //format array data for languages and initialize langOptions by force
        response.data.langValue = response.data.langValue.split(',');
        this.langOptions = JSON.parse(JSON.stringify(this.langList));

        //replace all person data
        this.personForm = response.data;

        //set new title + show success
        this.personTitle = this.personForm.firstname + " " + this.personForm.lastname;

      }, error => {
        //notification.showError(this, 'Daten konnten nicht geladen werden');
      })
    },

    getAllServices() {
      Vue.http.get(
          'api/v1/service/get-all'
      ).then(response => {
        this.serviceOptions = response.data.map(item => {
          return { value: item.id, label: item.name };
        });
      }, response => {
        //notification.showError(this, 'Daten konnten nicht geladen werden');
      })
    },

    GetAllLinkedCommunitiesOfMyService() {
      Vue.http.get(
          'api/v1/service/get-all-linked-communities'
      ).then(response => {
        this.communityOptions = response.data.map(item => {
          return { value: item.id, label: item.name };
        });
      }, response => {
        //notification.showError(this, 'Daten konnten nicht geladen werden');
      })
    },

    getAllTherapists() {
      Vue.http.get(
          'api/v1/therapist/get-all'
      ).then(response => {
        this.therapistOptions = response.data.map(item => {
          return { value: item.id, label: item.name };
        });
      }, response => {
        //notification.showError(this, 'Daten konnten nicht geladen werden');
      })
    },
  },

  beforeMount() {

    //default self for therapist id
    this.personForm.therapist = auth.user.profile.id;

    //default own service id
    this.personForm.service = auth.user.profile.serviceId;

    //default own service id as community id
    this.personForm.community = auth.user.profile.serviceId;

    // take child id as number > 0, else null
    this.personForm.id = Number(this.$route.params.childId) || null;

    //get child data, if childId is set
    if(this.personForm.id !== null) {
      this.getChildData();
    }

    //get all therapists in selected service
    this.getAllServices();

    //get all communities ("Gemeinden") linked to my service
    this.GetAllLinkedCommunitiesOfMyService();

    //get all therapists
    this.getAllTherapists();
  },

  mounted() {
    this.langList = langHelper.getLanguageIsoList().map(item => {
      return {value: item.iso, label: item.name};
    });
  },

  components: {
    childSessionsModule: childSessionsModule
  }
}

</script>